import { render, staticRenderFns } from "./LessonMarkdown.vue?vue&type=template&id=19cdb27c&scoped=true&"
import script from "./LessonMarkdown.vue?vue&type=script&lang=ts&"
export * from "./LessonMarkdown.vue?vue&type=script&lang=ts&"
import style0 from "./LessonMarkdown.vue?vue&type=style&index=0&id=19cdb27c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdb27c",
  null
  
)

export default component.exports